import { TextFieldProps } from '@mui/material'
import React from 'react'

import NumberField from '#/components/BaseField/number'
import { numberDisplayDefaultOptions } from '#/utils/numberDisplay'

type FormBuilderNumberProps = TextFieldProps & {
  type?: 'number' | 'integer'
  suffix?: React.ReactNode
  onChange?: (value: number | null) => void
  onBlur?: any
  value?: number | null
  error?: string | null
  format?: Intl.NumberFormatOptions
  precision?: number
  rules?: {
    min?: { value?: number }
    max?: { value?: number }
  }
}

export function FormBuilderNumber(props: FormBuilderNumberProps) {
  const {
    disabled,
    error,
    format,
    label,
    name,
    onBlur,
    onChange,
    precision,
    required,
    suffix,
    type = 'number',
    value,
  } = props

  const handleChange = value => {
    if (value === null) {
      onChange?.(null)
      return
    }

    if (type === 'integer') {
      return onChange?.(Math.trunc(value))
    }
    onChange?.(value)
  }

  const rules = {
    max: props?.rules?.max?.value,
    min: props?.rules?.min?.value,
  }

  return (
    <NumberField
      {...rules}
      disabled={disabled}
      name={name}
      required={required}
      label={label}
      onBlur={onBlur}
      value={value}
      onChange={handleChange}
      error={error}
      suffix={suffix}

      format={{
        maximumFractionDigits: precision ?? numberDisplayDefaultOptions.maximumFractionDigits,
        ...format,
      }}
    />
  )
}
